import type { ThemeConfig } from 'antd';
import { theme } from 'antd';

const fontFamily = [
  'Inter',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(', ');

export const seophenixTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  cssVar: {
    prefix: 'seophenix',
  },
  token: {
    colorPrimary: '#ff7a00',
    colorInfo: '#7c3aed',
    colorSuccess: '#0d9488',
    colorWarning: '#ff7a00',
    colorError: '#ba1a1a',
    colorTextBase: '#1f2937',
    colorBgBase: '#ffffff',
    colorBgLayout: '#f8fafc',
    colorBgContainer: '#ffffff',
    colorBorder: '#e5e7eb',
    colorBorderSecondary: '#f0f0f0',
    borderRadius: 8,
    borderRadiusSM: 4,
    borderRadiusLG: 12,
    fontFamily,
    fontSize: 14,
    controlHeight: 36,
    controlHeightSM: 28,
    controlHeightLG: 44,
    lineWidth: 1,
    boxShadowSecondary: '0 4px 12px rgba(15, 23, 42, 0.06)',
  },
  components: {
    Button: {
      borderRadius: 8,
      controlHeight: 36,
      fontWeight: 600,
      primaryShadow: 'none',
    },
    Card: {
      borderRadiusLG: 8,
      paddingLG: 24,
    },
    Input: {
      borderRadius: 8,
      controlHeight: 36,
      activeBorderColor: '#ff7a00',
      hoverBorderColor: '#ffb15f',
      activeShadow: '0 0 0 2px rgba(255, 122, 0, 0.14)',
    },
    Select: {
      borderRadius: 8,
      controlHeight: 36,
      optionSelectedBg: '#fff7e6',
      optionSelectedColor: '#ad4e00',
    },
    Modal: {
      borderRadiusLG: 12,
      contentBg: '#ffffff',
      headerBg: '#ffffff',
      footerBg: '#ffffff',
    },
    Tabs: {
      itemActiveColor: '#ff7a00',
      itemHoverColor: '#fa541c',
      itemSelectedColor: '#ff7a00',
      inkBarColor: '#ff7a00',
      titleFontSize: 14,
    },
    Table: {
      headerBg: '#fafafa',
      headerColor: '#6b7280',
      rowHoverBg: '#fffaf5',
      borderColor: '#f0f0f0',
    },
    Tag: {
      borderRadiusSM: 4,
      defaultBg: '#f8fafc',
      defaultColor: '#6b7280',
    },
    Layout: {
      bodyBg: '#f8fafc',
      headerBg: '#ffffff',
      siderBg: '#fafafa',
      triggerBg: '#fafafa',
      triggerColor: '#4b5563',
    },
    Menu: {
      itemBg: '#fafafa',
      itemColor: '#4b5563',
      itemHoverBg: '#fff7ed',
      itemHoverColor: '#ea580c',
      itemSelectedBg: '#f1f2f4',
      itemSelectedColor: '#ea580c',
      itemActiveBg: '#fff7ed',
      itemBorderRadius: 8,
      itemHeight: 40,
      iconSize: 16,
    },
  },
};
